{
	"withdrawCardLabel": "Montant comptabilisé dans les retraits effectués au cours de la période",
	"advanceCardLabel": "Montant comptabilisé dans les avances effectuées au cours de l'exercice",
	"totalLabel": "Somme des retraits et des avances effectués au cours de la période"
}
